import React from "react";
import CodeBlock from "./CodeBlock";

const GettingStarted = ({ data }) => {
  if (!data) return null;

  return (
    <div id="introduction">
      <h1>{data.title}</h1>
      <p className="apidocs-lead">{data.subtitle}</p>

      <div className="apidocs-facts">
        <div className="apidocs-fact hi">
          <div className="k">Base URL</div>
          <code>{data.baseUrl}</code>
        </div>
        <div className="apidocs-fact">
          <div className="k">Authentication</div>
          <code>X-API-Key</code>
        </div>
        <div className="apidocs-fact">
          <div className="k">Rate limit</div>
          <span>{data.rateLimit}</span>
        </div>
      </div>

      <h3>Quick start</h3>
      <div className="apidocs-steps">
        {data.steps.map((step, i) => (
          <div key={i} className="apidocs-step">
            <div className="n">{step.number}</div>
            <div>
              <h4>{step.title}</h4>
              <p>{step.description}</p>
              {step.code && <CodeBlock singleCode={step.code} singleLang="curl" />}
            </div>
          </div>
        ))}
      </div>

      <div className="apidocs-note">
        <b>Next</b>
        <p>Pick a Messaging or Flow endpoint in the list — the playground slides in from the right so you can try it without leaving this page.</p>
      </div>
    </div>
  );
};

export default GettingStarted;
